<template>
  <div
    v-loading="loading"
    :element-loading-text="$t('commonInfo.Loading')"
    class="main-frame"
  >
    <el-container>
      <el-header class="banner-head">
        <div class="head-info">
          <el-row>
            <el-col style="text-align: left" :span="12">
              <el-page-header
                style="color: #333333"
                :title="$t('commonInfo.Back')"
                @back="goBack"
                :content="$t('editStoreDetail.EditDetails')"
              ></el-page-header>
            </el-col>

            <el-col style="text-align: right" :span="12">
              <el-button @click="save_model_info('form')" type="primary">{{
                $t("editStoreDetail.Save")
              }}</el-button>
            </el-col>
          </el-row>
        </div>
      </el-header>
      <el-main>
        <el-form
          ref="form"
          :rules="rules"
          class="edit_module"
          :inline="true"
          :model="form"
        >
          <el-form-item
            :label="$t('editStoreDetail.Country')"
            prop="country_id"
          >
            <el-select
              v-model.trim="form.country_id"
              @change="get_country_info($event)"
              clearable
            >
              <el-option
                :label="item.name"
                :value="item.id"
                :key="item.id"
                v-for="item in form.country_list"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            :label="$t('editStoreDetail.Province')"
            prop="province_id"
          >
            <el-select
              :disabled="country_focus_flag"
              v-model.trim="form.province_id"
              @change="get_province_info($event)"
              clearable
            >
              <el-option
                :label="item.name"
                :value="item.id"
                :key="item.id"
                v-for="item in form.province_list"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('editStoreDetail.City')" prop="city_id">
            <el-select
              :disabled="country_focus_flag"
              v-model.trim="form.city_id"
              @change="get_city_info($event)"
              clearable
            >
              <el-option
                :label="item.name"
                :value="item.id"
                :key="item.id"
                v-for="item in form.city_list"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            :label="$t('editStoreDetail.TypeOfRetailArea')"
            prop="retail_area_type_id"
          >
            <el-select
              v-model.trim="form.retail_area_type_id"
              @change="get_retail_area_type_info($event)"
              clearable
            >
              <el-option
                :label="item.name"
                :value="item.id"
                :key="item.id"
                v-for="item in form.retail_area_type_list"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item
            :label="$t('editStoreDetail.CompanyName')"
            prop="company_name"
          >
            <el-input
              v-model.trim="form.company_name"
              style="padding-right: 14px"
            ></el-input>
          </el-form-item>

          <el-form-item :label="$t('editStoreDetail.area')" prop="area_size">
            <el-input v-model.trim="form.area_size">
              <i slot="suffix" style="font-style: normal; margin-right: 5px">{{
                form.area_unit
              }}</i>
            </el-input>
          </el-form-item>
          <el-form-item
            :label="$t('editStoreDetail.SellOutMoney')"
            prop="turnover"
          >
            <el-input v-model.trim="form.turnover">
              <i slot="suffix" style="font-style: normal; margin-right: 5px">{{
                form.turnover_unit
              }}</i></el-input
            >
          </el-form-item>
          <el-form-item
            :label="$t('editStoreDetail.SMOKSellOutMoney')"
            prop="smok_turnover"
          >
            <el-input v-model.trim="form.smok_turnover">
              <i slot="suffix" style="font-style: normal; margin-right: 5px">{{
                form.turnover_unit
              }}</i></el-input
            >
          </el-form-item>
          <el-form-item :label="$t('editStoreDetail.EditContactInformation')">
            <el-input
              v-model.trim="form.add_contact"
              @focus="dialogVisible = true"
              style="padding-right: 14px"
            >
              >
            </el-input>
          </el-form-item>
          <el-form-item
            :label="$t('editStoreDetail.StoreAddress')"
            prop="address"
          >
            <el-input
              v-model.trim="form.address"
              style="padding-right: 14px"
            ></el-input>
          </el-form-item>
          <el-form-item :label="$t('editStoreDetail.StoreZipCode')">
            <el-input
              v-model.trim="form.zip"
              style="padding-right: 14px"
            ></el-input>
          </el-form-item>

          <el-form-item :label="$t('editStoreDetail.Number')">
            <el-input
              disabled
              v-model.trim="form.number"
              style="padding-right: 14px"
            ></el-input>
          </el-form-item>
          <!-- <el-form-item label="营业年度：">
            <el-input
              disabled
              v-model.trim="form.business_operation_year"
              style="padding-right: 14px"
            ></el-input>
          </el-form-item>

          <el-form-item label="开放时间：">
            <el-input
              disabled
              v-model.trim="form.opening_time"
              style="padding-right: 14px"
            ></el-input>
          </el-form-item> -->
          <el-form-item :label="$t('editStoreDetail.OutletStatus')">
            <el-input
              disabled
              v-model.trim="form.outlet_status"
              style="padding-right: 14px"
            ></el-input>
          </el-form-item>
          <el-form-item :label="$t('editStoreDetail.Picture')">
            <el-input
              disabled
              v-model.trim="form.pictures"
              style="padding-right: 14px"
            ></el-input>
          </el-form-item>
          <el-form-item :label="$t('editStoreDetail.ImageLink')">
            <el-input
              disabled
              v-model.trim="form.pictures_url"
              style="padding-right: 14px"
            ></el-input>
          </el-form-item>
          <el-form-item :label="$t('editStoreDetail.Score')">
            <el-input
              disabled
              v-model.trim="form.score"
              style="padding-right: 14px"
            ></el-input>
          </el-form-item>
          <el-form-item :label="$t('editStoreDetail.DateDate')">
            <el-input
              disabled
              v-model.trim="form.statistics_date"
              style="padding-right: 14px"
            ></el-input>
          </el-form-item>
        </el-form>
        <!-- 添加联系人弹框 -->
        <el-dialog
          :title="$t('contactMethods.Edit')"
          :visible.sync="dialogVisible"
          width="70%"
        >
          <el-form
            ref="add_contact_form"
            :model="add_contact_form"
            :inline="true"
            label-width="70px"
            :rules="add_contact_rules"
          >
            <ul>
              <li
                :key="index"
                v-for="(
                  item, index
                ) in add_contact_form.contact_information_list"
              >
                <el-form-item :label="$t('contactMethods.Position')">
                  <el-input v-model.trim="item.position"></el-input>
                </el-form-item>
                <el-form-item :label="$t('contactMethods.Name')">
                  <el-input v-model.trim="item.name"></el-input>
                </el-form-item>
                <el-form-item :label="$t('contactMethods.Tel')">
                  <el-input v-model.trim="item.phone"></el-input>
                </el-form-item>
                <el-form-item :label="$t('contactMethods.Email')">
                  <el-input v-model.trim="item.e_mail"></el-input>
                </el-form-item>
                <el-button type="primary" @click="delete_contact(index)">{{
                  $t("contactMethods.Delete")
                }}</el-button>
              </li>
            </ul>
            <div style="text-align: right">
              <el-button type="primary" @click="add_contacts">{{
                $t("contactMethods.Add")
              }}</el-button>
            </div>
          </el-form>
          <span slot="footer" class="dialog-footer">
            <el-button @click="cancel_add_contact('add_contact_form')">{{
              $t("contactMethods.Cancel")
            }}</el-button>
            <el-button
              type="primary"
              @click="add_contact_success('add_contact_form')"
              >{{ $t("contactMethods.Confirm") }}</el-button
            >
          </span>
        </el-dialog>
      </el-main>
    </el-container>
  </div>
</template>

<script>
export default {
  name: "AddStoreInfo",
  data() {
    return {
      loading: false,
      dialogVisible: false,
      // 单项门店具体信息
      form: {
        country_list: [],
        province_list: [],
        city_list: [],
        country_id: "",
        province_id: "",
        city_id: "",
        retail_area_type_list: [],
        retail_area_type_id: "",
        company_name: "", //门店名称
        zip: "", //邮编
        address: "", //门店地址
        add_contact: "", //编辑联系人
        retail_type_id: "", //零售区类型id
        area_size: "", //门店面积
        turnover: "", //营业额
        smok_turnover: "", //smok营业额
        area_unit: "", //面积单位
        turnover_unit: "", //营业额单位
      },
      // 编辑联系人列表
      add_contact_form: {
        contact_information_list: [
          {
            position: "",
            name: "",
            phone: "",
            e_mail: "",
          },
        ],
        contact_information_list_clone: [
          {
            position: "",
            name: "",
            phone: "",
            e_mail: "",
          },
        ],
      },
      // 刚进页面存储一个联系人信息
      // contact_info_list_copy: [],
      // 表单触发规则
      rules: {
        country_id: [
          {
            required: true,
            message: this.$t("commonInfo.EnterInformation"),
            trigger: ["change"],
          },
        ],
        province_id: [
          {
            required: true,
            message: this.$t("commonInfo.EnterInformation"),
            trigger: ["change"],
          },
        ],
        city_id: [
          {
            required: true,
            message: this.$t("commonInfo.EnterInformation"),
            trigger: ["change"],
          },
        ],
        retail_area_type_id: [
          {
            required: true,
            message: this.$t("commonInfo.EnterInformation"),
            trigger: ["change"],
          },
        ],
        company_name: [
          {
            required: true,
            message: this.$t("commonInfo.EnterInformation"),
            trigger: ["blur"],
          },
        ],
        area_size: [
          {
            required: true,
            message: this.$t("commonInfo.EnterInformation"),
            trigger: ["blur"],
          },
        ],
        turnover: [
          {
            required: true,
            message: this.$t("commonInfo.EnterInformation"),
            trigger: ["blur"],
          },
        ],
        smok_turnover: [
          {
            required: true,
            message: this.$t("commonInfo.EnterInformation"),
            trigger: ["blur"],
          },
        ],
        add_contact: [
          {
            required: true,
            message: this.$t("commonInfo.EnterInformation"),
            trigger: ["blur", "change"],
          },
        ],
        address: [
          {
            required: true,
            message: this.$t("commonInfo.EnterInformation"),
            trigger: ["blur"],
          },
        ],
      },
      // 添加联系人校验
      add_contact_rules: {
        position: [
          {
            required: true,
            message: this.$t("commonInfo.EnterInformation"),
            trigger: ["blur"],
          },
        ],
        name: [
          {
            required: true,
            message: this.$t("commonInfo.EnterInformation"),
            trigger: ["blur"],
          },
        ],
        phone: [
          {
            required: true,
            message: this.$t("commonInfo.EnterInformation"),
            trigger: ["blur"],
          },
        ],
        e_mail: [
          {
            required: true,
            message: this.$t("commonInfo.EnterInformation"),
            trigger: ["blur"],
          },
        ],
      },
      country_focus_flag: false,
    };
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    // 获取国家id
    get_country_info(e) {
      this.form.country_id = e;
      this.form.province_id = "";
      this.form.city_id = "";
      this.get_province_list(e);
    },
    // 获取省份id
    get_province_info(e) {
      this.form.province_id = e;
      this.form.city_id = "";
      this.get_city_list(e);
    },
    // 获取城市id
    get_city_info(e) {
      this.form.city_id = e;
    },
    // 获取省份列表
    get_province_list(country_id) {
      let _me = this;
      _me.loading = true;
      let params = {
        id: country_id,
      };
      this.$common
        .httpPost("/api/address/province/find/list", params)
        .then((res) => {
          _me.loading = false;
          if (res.code == "1000000") {
            this.form.province_list = res.data;
          } else {
            _me.$message.error(res.message);
          }
        })
        .catch((err) => {
          _me.loading = false;
          if (err.code == 1000009 || err.code == 1000007) {
            this.$router.push("sign-in");
          }
          _me.$message.error(err.message);
        });
    },
    // 获取城市列表
    get_city_list(province_id) {
      let _me = this;
      _me.loading = true;
      let params = {
        id: province_id,
      };
      this.$common
        .httpPost("/api/address/city/find/list", params)
        .then((res) => {
          _me.loading = false;
          if (res.code == "1000000") {
            this.form.city_list = res.data;
          } else {
            _me.$message.error(res.message);
          }
        })
        .catch((err) => {
          _me.loading = false;
          if (err.code == 1000009 || err.code == 1000007) {
            this.$router.push("sign-in");
          }
          _me.$message.error(err.message);
        });
    },
    get_retail_area_type_info(e) {
      this.form.retail_area_type_list =
        this.$common.get_retail_type_list_info();
      this.form.retail_area_type_id = e;
    },
    // 添加联系人成功操作
    add_contact_success(add_contact_form) {
      // this.$refs[add_contact_form].validate((valid) => {
      //   if (valid) {
      let contact_information_list = JSON.parse(
        JSON.stringify(this.add_contact_form.contact_information_list)
      );
      for (let item of contact_information_list) {
        if (item.name !== "" || item.phone !== "" || item.position !== "") {
          this.dialogVisible = false;
          this.add_contact_form.contact_information_list_clone =
            this.$common.deepClone(
              this.add_contact_form.contact_information_list
            );
          // this.form.add_contact = "已添加";
          // }
          // });
        }
      }
    },

    // 编辑门店信息并保存
    save_model_info(form) {
      this.loading = true;
      let _me = this;
      _me.form.contact_information_list.forEach((item, index) => {
        item.id = item.id;
        item.store_id = item.store_id;
      });
      _me.add_contact_form.contact_information_list_clone =
        this.$common.deepClone(this.add_contact_form.contact_information_list);
      let params = {
        id: _me.$route.query.id,
        country_id: _me.form.country_id,
        province_id: _me.form.province_id,
        city_id: _me.form.city_id,
        company_name: _me.form.company_name,
        retail_area_type_id: _me.form.retail_area_type_id,
        address: _me.form.address,
        contact_information_list: JSON.stringify(
          _me.add_contact_form.contact_information_list_clone
        ),
        address: _me.form.address,
        area_size: Number(_me.form.area_size),
        turnover: Number(_me.form.turnover),
        smok_turnover: Number(_me.form.smok_turnover),
        zip: _me.form.zip,
      };
      // 验证通过才发起请求
      _me.$refs[form].validate((valid) => {
        if (valid) {
          _me.$common
            .httpPost("/api/store/admin/update/one", params)
            .then((res) => {
              _me.loading = false;
              if (res.code == 1000000) {
                _me.$message.success(this.$t("editStoreDetail.EditSuccess"));
                _me.$router.go(-1);
              } else {
                _me.$message.error(res.message);
              }
            })
            .catch((err) => {
              _me.loading = false;
              if (err.code == 1000009 || err.code == 1000007) {
                _me.$router.push("sign-in");
              }
              _me.$message.error(err.message);
            });
        }
      });
    },
    // 切换新旧版数据
    switch_new_old(value) {
      if (value) {
        this.form.page_flag = 1;
      } else {
        this.form.page_flag = 2;
      }
    },
    // 获取单项门店全部数据
    get_store_item_info(id) {
      let _me = this;
      _me.loading = true;
      let params = {
        id: id,
      };
      this.$common
        .httpPost("/api/store/admin/find/one", params)
        .then((res) => {
          _me.loading = false;
          if (res.code == "1000000") {
            let country_id = res.data.country_id;
            let country_related_info =
              this.$common.get_country_related_info(country_id);
            let area_unit = " " + country_related_info.area_unit;
            let turnover_unit = " " + country_related_info.turnover_unit;
            res.data.area_unit = area_unit;
            res.data.turnover_unit = turnover_unit;
            // 面积
            let max_area_size = res.data.max_area_size,
              min_area_size = res.data.min_area_size;
            if (max_area_size == -1) {
              res.data.area_size = Math.round(Number(min_area_size));
            } else {
              res.data.area_size = Math.round(
                (Number(max_area_size) + Number(min_area_size)) / 2
              );
            }
            // 营业额
            let max_turnover = res.data.max_turnover,
              min_turnover = res.data.min_turnover;
            if (max_turnover == -1) {
              res.data.turnover = Math.round(Number(min_turnover));
            } else {
              res.data.turnover = Math.round(
                (Number(max_turnover) + Number(min_turnover)) / 2
              );
            }
            // smok营业额
            let max_smok_turnover = res.data.max_smok_turnover,
              min_smok_turnover = res.data.min_smok_turnover;
            if (max_smok_turnover == -1) {
              res.data.smok_turnover = Math.round(Number(min_smok_turnover));
            } else {
              res.data.smok_turnover = Math.round(
                (Number(max_smok_turnover) + Number(min_smok_turnover)) / 2
              );
            }
            // if (min == max) {
            //   res.data.area_size = max;
            // } else if (max == -1) {
            //   res.data.area_size = ">" + min;
            // } else {
            //   res.data.area_size = min + " - " + max;
            // }
            // res.data.area_size = Math.ceil(
            //   Number(res.data.max_area_size) +
            //     Number(res.data.min_area_size) / 2
            // );
            // res.data.turnover = Math.ceil(
            //   Number(res.data.max_turnover) + Number(res.data.min_turnover) / 2
            // );
            // res.data.smok_turnover = Math.ceil(
            //   Number(res.data.max_smok_turnover) +
            //     Number(res.data.min_smok_turnover) / 2
            // );
            Object.assign(_me.form, res.data);
            _me.add_contact_form.contact_information_list =
              res.data.contact_information_list;
            // _me.contact_info_list_copy = res.data.contact_information_list;
            // JSON.parse(
            //   JSON.stringify(res.data.contact_information_list)
            // ).forEach((item, index) => {
            //   _me.contact_info_list_copy.push(item);
            // });
          } else {
            _me.$message.error(res.message);
          }
        })
        .catch((err) => {
          _me.loading = false;
          if (err.code == 1000009 || err.code == 1000007) {
            this.$router.push("sign-in");
          }
          _me.$message.error(err);
        });
    },
    // 添加联系人
    add_contacts() {
      this.add_contact_form.contact_information_list.push({
        position: "",
        name: "",
        phone: "",
        e_mail: "",
      });
    },
    // 删除联系人
    delete_contact(index) {
      if (this.add_contact_form.contact_information_list.length > 1) {
        this.add_contact_form.contact_information_list.splice(index, 1);
      }
    },
    // 初始化国家列表
    get_country_list_initial() {
      this.$common
        .get_storage_list(
          "country_list",
          "http_get",
          "/api/address/country/find/list"
        )
        .then((res) => {
          this.form.country_list = res;
        })
        .catch((err) => {});
    },
    // 初始化省份列表
    get_province_list_initial() {
      this.$common
        .get_storage_list(
          "province_list",
          "http_post",
          "/api/address/province/find/list"
        )
        .then((res) => {
          this.form.province_list = res;
        })
        .catch((err) => {});
    },
    // 初始化城市列表
    get_city_list_initial() {
      this.$common
        .get_storage_list(
          "city_list",
          "http_post",
          "/api/address/city/find/list"
        )
        .then((res) => {
          this.form.city_list = res;
        })
        .catch((err) => {});
    },
    // 获取零售区类型列表
    get_retail_area_type_list_initial() {
      this.$common
        .get_storage_list(
          "retail_area_type_list",
          "http_get",
          "/api/store/admin/retail/area/type/find/list"
        )
        .then((res) => {
          this.form.retail_area_type_list = res;
        })
        .catch((err) => {});
    },
    // 点击遮罩层
    handleClose() {},
    // 取消添加联系人
    cancel_add_contact() {
      this.dialogVisible = false;
    },
    // 重置联系人表单并关闭遮罩层
    resetContactForm() {
      this.dialogVisible = false;
      // let contact_information_list =
      //   this.add_contact_form.contact_information_list;
      // contact_information_list.forEach((item, index) => {
      //   item.e_mail = "";
      //   item.name = "";
      //   item.phone = "";
      //   item.position = "";
      // });
      // console.log(this.contact_info_list_copy);
      // this.add_contact_form.contact_information_list =
      //   this.contact_info_list_copy;
      this.add_contact_form.contact_information_list = [];
      // this.contact_info_list_copy.forEach((item, index) => {
      //   this.add_contact_form.contact_information_list.push(item);
      // });
    },
  },
  created() {},
  mounted() {
    // 初始化国家列表
    this.get_country_list_initial();
    // 初始化省份列表
    this.get_province_list_initial();
    // 初始化城市列表
    this.get_city_list_initial();
    // 初始化零售区类型
    this.get_retail_area_type_list_initial();
    // 初始化评分标准
    this.$common.get_score_stard_list_info();
    // 获取单个门店的基本数据
    let pre_item_id = this.$route.query.id;
    if (pre_item_id) {
      this.get_store_item_info(pre_item_id);
    }
  },
  watch: {
    "form.country_id"() {
      if (this.form.country_id) {
        this.country_focus_flag = false;
      } else {
        this.country_focus_flag = true;
      }
    },
  },
};
</script>

<style scoped>
.banner-head {
  /*background-color: white;*/
  background-color: #f1f1f1;
  height: 60px;
}

.head-info {
  color: #ffffff;
}

main > form.edit_module {
  display: flex;
  flex-wrap: wrap;
  margin: 20px 0;
  /* justify-content: center; */
  /* justify-content: space-between; */
}
main > form.edit_module > div {
  /* margin: 20px 0; */
  width: 25%;
  text-align: right;
  margin: 20px;
  /* display: flex; */
  /* justify-content: space-around; */
  /* align-items: right; */
  /* flex-direction: column; */
}
</style>
